var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__clip0_5627_107163)",
    fill: "#85A5FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.603 18.306c4.385 1.175 2.73 7.841-1.662 6.665-4.384-1.175-2.73-7.842 1.662-6.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.527 13.621c-.503-.13-1.037-.267-1.603-.418v-.002c-6.636-1.77-7.297-1.813-9.307 6.247-1.986 7.968-1.815 8.257 6.114 10.382.4.107.792.217 1.175.324 3.783 1.058 6.71 1.877 7.959-2.31 3.63-12.168 2.72-12.402-4.338-14.223zm2.694 3.783a1.21 1.21 0 011.493-.879c.659.177 1.06.857.895 1.52a1.21 1.21 0 01-1.493.879 1.262 1.262 0 01-.895-1.52zM16.662 20.27a5.18 5.18 0 016.39-3.765c2.822.756 4.536 3.668 3.829 6.503a5.179 5.179 0 01-6.389 3.764c-2.822-.756-4.537-3.667-3.83-6.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.045 14.941c1.146-4.82 1.611-6.778 3.854-8.158 2.352-1.445 4.387-.881 11.513 1.092 1.475.409 3.169.878 5.13 1.402 3.16.853 3.332.927 3.91 1.175l.033.014c2.64 1.13 4.231 3.642 3.65 7.105-.077.463-3.675 14.893-3.82 15.328-1.044 3.118-3.323 4.456-5.71 4.436-1.787-.013-16.683-4.004-18.256-4.89-4.33-2.441-3.082-6.968-1.709-11.954.225-.813.452-1.639.66-2.47.284-1.14.527-2.162.745-3.08zm14.237-3.569c.325.09.652.18.98.268.392.105.77.204 1.138.3 3.184.83 5.44 1.418 6.723 3.596 1.279 2.169.712 4.39-.129 7.684a204 204 0 00-.274 1.084l-.247 1c-.592 2.413-1.018 4.149-1.908 5.408-2.244 3.154-5.707 2.192-9.263 1.204a115.213 115.213 0 00-2.005-.538c-3.692-.96-7.105-1.849-7.587-5.719-.191-1.538.333-3.61.903-5.863.069-.272.139-.547.207-.824l.244-.988c.593-2.414 1.025-4.174 1.912-5.421 2.233-3.14 5.608-2.21 9.306-1.19z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__clip0_5627_107163"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.96593 .25882 -.24194 .9703 9 0)",
    d: "M0 0h36v36H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/instagram.e2c3469d5b91497f910c0c05ca84a1db.svg";
export { SvgInstagram as ReactComponent };